export const columnsDataComplaints = [
  {
    Header: "SR. No.",
    accessor: "sr_no",
  },
  {
    Header: "MES JOB No.",
    accessor: "mes_no",
  },
  {
    Header: "SUBJECT",
    accessor: "subject",
  },
  // {
  //   Header: "NATURE OF COMPLAINT",
  //   accessor: "natureOfComplaint",
  // },
  {
    Header: "LOCATION",
    accessor: "location",
  },
  {
    Header: "NATURE OF COMPLAINT",
    accessor: "complaintType",
  },
  {
    Header: "EXPECTED DATE TO RESOLVE",
    accessor: "expectedDateToResolve",
  },

  {
    Header: "SUBMITTED DATE",
    accessor: "submittedDate",
  },
  {
    Header: "COMPLAINT STATUS",
    accessor: "complaintStatus",
  },
  {
    Header: "ACTION",
    accessor: "actionId",
  },
];
